/**
 * Turns query string like hello=1&another=2 into object {hello: 1, another: 2}
 * @param {*} queryString
 */

function parseQuery(queryString) {
  var query = {};
  var pairs = (
    queryString[0] === "?" ? queryString.substring(1) : queryString
  ).split("&");
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split("=");
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
  }
  return query;
}

function modifyColor(col, amt) {
  var usePound = false;

  if (col[0] == "#") {
    col = col.slice(1);
    usePound = true;
  }

  var num = parseInt(col, 16);

  var r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  var b = ((num >> 8) & 0x00ff) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  var g = (num & 0x0000ff) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (
    (usePound ? "#" : "") +
    String("000000" + (g | (b << 8) | (r << 16)).toString(16)).slice(-6)
  );
}

function addAlpha(color, opacity) {
  const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
  return color + _opacity.toString(16).toUpperCase();
}

function parsePrice(price, thousandSeparator, decimalSeparator) {
  if (!price) {
    return "";
  }
  const regEx = new RegExp(
    `([0-9${thousandSeparator}]+)(\\${decimalSeparator}\\d+)?`
  );
  const [_ignored, int, decimals] = price.match(regEx);
  return parseFloat(
    `${int.replace(/[^0-9]/g, "")}.${(decimals || "0").replace(/[^0-9]/g, "")}`
  );
}

function formatPrice(price) {
  if (!price) {
    return "";
  }
  let cleanedPrice = price.toString().replace("kr", "").trim();

  cleanedPrice = cleanedPrice.split(".")[0];

  cleanedPrice = cleanedPrice.replace(",", " ");

  let formattedPrice = `${cleanedPrice},-`;

  return formattedPrice;
}

function checkGTM() {
  const scripts = document.head.getElementsByTagName("script");
  for (let i = 0; i < scripts.length; i++) {
    if (scripts[i].src.includes("www.googletagmanager.com")) {
      return true;
    }
  }
  return false;
}

const updateDataLayer = (datalayerFunction) => {
  const interval = setInterval(async () => {
    if (checkGTM()) {
      window.dataLayer = window.dataLayer ?? [];
      window.dataLayer.push({ ecommerce: null });
      await datalayerFunction();
      clearInterval(interval);
    }
  }, 200);
};

const norwegianMonths = [
  "januar",
  "februar",
  "mars",
  "april",
  "mai",
  "juni",
  "juli",
  "august",
  "september",
  "oktober",
  "november",
  "desember",
];

function formatDate(dateString) {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = norwegianMonths[date.getMonth()].slice(0, 3);
  const year = date.getFullYear();

  return {
    day: day.toString().padStart(2, "0"),
    month,
    year: year.toString(),
  };
}

function formatDateWithWeekDay(dateString) {
  const date = new Date(dateString);
  const options = { weekday: "long" };
  let weekdayName = date.toLocaleString("nb-NO", options);
  weekdayName = weekdayName.charAt(0).toUpperCase() + weekdayName.slice(1);
  return `${weekdayName}, ${dateString}`;
}

function removeHtmlTags(text) {
  const regex = /(<([^>]+)>)/gi;
  return text.replace(regex, " ");
}

function extractFirstNumber(str) {
  const match = str.match(/\d+/);
  return match ? parseInt(match[0], 10) : 0;
}

module.exports = {
  parseQuery,
  addAlpha,
  modifyColor,
  parsePrice,
  formatPrice,
  updateDataLayer,
  formatDate,
  removeHtmlTags,
  extractFirstNumber,
  formatDateWithWeekDay,
};
